import { computed, Injectable, Signal, signal } from '@angular/core';
import { FeatureFlag, FeatureFlags } from '@app/core/feature-flags/feature-flag.types';

@Injectable({ providedIn: 'root' })
export class FeatureFlagStore {
  featureFlags = signal<Record<string, boolean>>({});

  updateFeatureFlags(featureFlags: FeatureFlag[]): void {
    this.featureFlags.update((currentFlags) => {
      const newFlags = featureFlags.reduce<Record<string, boolean>>((acc, flag) => {
        acc[flag.name] = flag.isEnabled;
        return acc;
      }, {});
      return { ...currentFlags, ...newFlags };
    });
  }

  getFeatureFlag(key: FeatureFlags): Signal<boolean> {
    return computed(() => this.featureFlags()[key] ?? false);
  }
}
